import React, { Component } from 'react';
import PropTypes from 'prop-types';
import pick from 'lodash/pick';
import isEqual from 'lodash/isEqual';
import PlanImpact from '../../PlanImpact/PlanImpactContainer';
import AdvForm from '../../../CommonComponents/AdvForm';
import Footer from '../../Footer/FooterContainer';
import Loading from '../../Loading/LoadingView';
import { isNumeric, isUuid, createCustomPropType } from '../../../../js/app/react/validators';
import ValidationErrors from '../../ValidationErrors/ValidationErrorsContainer';
import AdvInput, { advInputTextChanged } from '../../../CommonComponents/AdvInput';
import AdvInputWrapper from '../../../CommonComponents/AdvInputWrapper';

class PurchaseFrequencyChangesView extends Component {
  constructor() {
    super();
    this.onNumericInputBlur = this.onNumericInputBlur.bind(this);
  }
  componentDidMount() {
    const {
      fetchData,
      clientId,
      fpId,
      goalId,
      fetchInitialPlanImpact,
      whatIf,
      whatIfTemplate,
    } = this.props;
    fetchData(clientId, fpId, goalId, whatIfTemplate.WhatIfType);
    fetchInitialPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
  }

  componentDidUpdate(previousProps) {
    const {
      clientId, fpId, goalId, whatIf, fetchPlanImpact, whatIfTemplate,
    } = this.props;

    const impactTriggerProps = ['whatIf'];

    if (!isEqual(pick(this.props, impactTriggerProps), pick(previousProps, impactTriggerProps))) {
      fetchPlanImpact(clientId, fpId, goalId, whatIf, whatIfTemplate);
    }
  }

  onNumericInputBlur(apiPath) {
    return (valueArg) => {
      const {
        goalId, clientId, whatIfTemplate, storeData,
      } = this.props;
      let value = valueArg;
      if (isNumeric(valueArg)) {
        if (typeof valueArg === 'string') {
          value = +valueArg;
        }
      } else {
        value = 0;
      }
      advInputTextChanged(clientId, storeData(goalId, whatIfTemplate.WhatIfType), apiPath)(value);
    };
  }

  render() {
    const {
      goalId,
      clientId,
      loading,
      title,
      groupTitle,
      fpId,
      whatIf,
      whatIfTemplate,
      applyWhatIf,
      areOptionsLoaded,
      planImpactItems,
      repeatEveryNYears,
      repeatForNYears,
      inflation,
      inflationChanged,
    } = this.props;
    const { ADV } = window;
    return (
      <div className="what-ifs-layout">
        {loading && <Loading />}
        <div className="what-ifs-section what-ifs-layout-header">
          <h3>What-If...</h3>
        </div>
        <div className="what-ifs-layout-content">
          <h4 className="what-if-group-title">{groupTitle}</h4>
          <AdvForm>
            <ValidationErrors clientId={clientId} />
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">{title}</h5>
              </li>

              <li className="what-ifs-form-field what-ifs-large-purchase-frequency-layout-container">
                <div className="what-ifs-large-purchase-frequency-layout-element what-ifs-large-purchase-text">
                  Every
                </div>
                <AdvInputWrapper className="what-ifs-input-wrapper what-ifs-large-purchase-frequency-input-wrapper what-ifs-large-purchase-frequency-layout-element">
                  <AdvInput
                    autoComplete="off"
                    type="text"
                    dataType="integer"
                    maxLength="14"
                    onBlur={this.onNumericInputBlur('WhatIf.RepeatEveryNYears')}
                    value={ADV.util.formatValue(repeatEveryNYears, 'integer')}
                    className="what-ifs-input what-ifs-large-purchase-frequency-input"
                  />
                </AdvInputWrapper>
                <div className="what-ifs-large-purchase-frequency-layout-element what-ifs-large-purchase-text">
                  year{isNumeric(repeatEveryNYears) && +repeatEveryNYears === 1 ? '' : 's'}
                </div>
              </li>

              <li className="what-ifs-form-field what-ifs-large-purchase-frequency-layout-container">
                <div className="what-ifs-large-purchase-frequency-layout-element what-ifs-large-purchase-text">
                  for
                </div>
                <AdvInputWrapper className="what-ifs-input-wrapper what-ifs-large-purchase-frequency-input-wrapper what-ifs-large-purchase-frequency-layout-element">
                  <AdvInput
                    autoComplete="off"
                    type="text"
                    dataType="integer"
                    maxLength="14"
                    onBlur={this.onNumericInputBlur('WhatIf.RepeatForNYears')}
                    value={ADV.util.formatValue(repeatForNYears, 'integer')}
                    className="what-ifs-input what-ifs-large-purchase-frequency-input"
                  />
                </AdvInputWrapper>
                <div className="what-ifs-large-purchase-frequency-layout-element what-ifs-large-purchase-text">
                  year{isNumeric(repeatForNYears) && +repeatForNYears === 1 ? '' : 's'}
                </div>
              </li>
            </ul>
            <ul className={`what-ifs-form-fields what-ifs-box${areOptionsLoaded ? ' loaded' : ''}`}>
              <li className="what-ifs-form-field">
                <h5 className="what-if-title">Inflation changes?</h5>
              </li>
              <li className="what-ifs-form-field what-ifs-stress-test-inflation">
                <AdvInputWrapper hasPercentage className="what-ifs-input-wrapper">
                  <AdvInput
                    type="text"
                    dataType="interest"
                    maxLength="14"
                    onBlur={inflationChanged(clientId, goalId, whatIfTemplate.WhatIfType)}
                    nullable
                    value={ADV.util.formatValue(inflation, 'interest')}
                    className="what-ifs-input"
                  />
                </AdvInputWrapper>
              </li>
            </ul>
          </AdvForm>
        </div>
        <PlanImpact clientId={clientId} planImpactItems={planImpactItems} />
        <Footer
          clientId={clientId}
          applyToPlanCallback={applyWhatIf(clientId, fpId, goalId, whatIf, whatIfTemplate)}
        />
      </div>
    );
  }
}
PurchaseFrequencyChangesView.defaultProps = {
  title: 'Untitled What If',
  groupTitle: 'Untitled What If Group',
  repeatEveryNYears: '',
  repeatForNYears: '',
};

PurchaseFrequencyChangesView.propTypes = {
  planImpactItems: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    current: PropTypes.string.isRequired,
    proposed: PropTypes.string.isRequired,
  })).isRequired,
  goalId: createCustomPropType(isUuid).isRequired,
  fpId: createCustomPropType(isUuid).isRequired,
  clientId: createCustomPropType(isNumeric).isRequired,
  title: PropTypes.string,
  groupTitle: PropTypes.string,
  areOptionsLoaded: PropTypes.bool.isRequired,
  whatIf: PropTypes.shape({}).isRequired,
  whatIfTemplate: PropTypes.shape({}).isRequired,
  fetchPlanImpact: PropTypes.func.isRequired,
  fetchData: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  fetchInitialPlanImpact: PropTypes.func.isRequired,
  applyWhatIf: PropTypes.func.isRequired,
  storeData: PropTypes.func.isRequired,
  repeatEveryNYears: createCustomPropType(isNumeric),
  repeatForNYears: createCustomPropType(isNumeric),
  inflation: PropTypes.number.isRequired,
  inflationChanged: PropTypes.func.isRequired,
};

export default PurchaseFrequencyChangesView;
